export const mdl11Urls = {
  searchQuotes: 'alucore-mdl11/api/quotes/search',
  searchSalesOrders: 'alucore-mdl11/api/sales-orders/search',
  searchDispatches: 'alucore-mdl11/api/dispatches/search',
  fullfillmentPlanDispatchUrl: 'mdl11/searchFulFillmentPlanTyDispatch',
  creditAccUrl: 'mdl11/CreditAccount?CustomerId=',
  getAllCreditAccount: 'mdl11/CreditAccount/Search',
  salesRelatedDocuments: '/mdl11/salesRelatedDocuments/Post',
  searchSalesDocuments: '/mdl11/SearchSalesDocuments/Post',
  searchSalesDocumentDetail: '/mdl11/SearchSalesDocumentDetail',
  salesAgentsUrl: '/mdl11/salesAgent/search',
  pdfURL: '/mdl11/GeneratePDF',
  emailURL: '/mdl11/ForwardEmailSalesDocuments/Post',
  ReasonCancellation: '/mdl11/ReasonCancellation',
  cannalURL: 'mdl11/getInputChannels/',
  addCotizationURL: 'mdl11/AddUpdateSalesDocuments/Post',
  getApprovallSalesOrder: 'mdl11/GetApprovalSalesOrder',
  updateApprovalSalesOrder: 'mdl11/UpdateApprovalSalesOrder',
  documentHistory: 'mdl11/documentHistory/post',
  getOdcDocument: 'mdl11/documentHistory',
  updateDocumentStatus: 'mdl11/updateDocumentStatus',
  paintingHistory: 'mdl11/historyColorVariantsCustomer',
  billingFlowPickingBranch: '/mdl11/billingFlowPickingBranch',
}
